export default "/_next/static/images/1df0511f66ddc52f33f7818c27a27f45.png";